import {Badge} from "@/components/ui/badge";
import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip";
import {cn} from "@/lib/utils";

import type {VehicleListStatusBadge as VehicleListStatusBadgeDisplay} from "../lib/vehicle-list-amenity-badges";

export function VehicleListStatusBadge({
  display,
  className,
}: {
  display: VehicleListStatusBadgeDisplay;
  className?: string;
}) {
  const badge = (
    <Badge variant={display.variant} className={cn(className)}>
      {display.label}
    </Badge>
  );

  if (!display.tooltip) return badge;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span className="inline-flex" tabIndex={0}>
            {badge}
          </span>
        }
      />
      <TooltipContent>{display.tooltip}</TooltipContent>
    </Tooltip>
  );
}
